import React from "react";
import {
  BlackBgk,
  CloseIcon,
  FontSizeDown,
  FontSizeUp,
  LineDown,
  LineUp,
  WhiteBgk
} from "./controlsIcons";
import { getStoredNovelSettings } from "./settingsHandling";

export function NovelReadingControlsView({ t, onClose, settingsUpdaters }) {
  // local state only for showing current bg
  // is synced with localsotre updaters
  const [currentSettings, setCurrentSettings] = React.useState(getStoredNovelSettings());
  const { bg } = currentSettings;
  function updateSettings(updater) {
    return function doUpdate() {
      setCurrentSettings(state => ({ ...state, ...updater(state) }));
    };
  }
  return (
    <div className="a-novel-settings">
      <div className="relative">
        <h3>{t.bgk}</h3>
        <BlackBgk onClick={updateSettings(settingsUpdaters.setBgBlack)} selected={bg === "black"} />
        <WhiteBgk onClick={updateSettings(settingsUpdaters.setBgWhite)} selected={bg === "white"} />

        <h3>{t.font_size}</h3>
        <FontSizeDown onClick={updateSettings(settingsUpdaters.setFsSmaller)} />
        <FontSizeUp onClick={updateSettings(settingsUpdaters.setFsBigger)} />

        <h3>{t.line_height}</h3>
        <div className="flex items-center">
          <LineDown onClick={updateSettings(settingsUpdaters.setLhSmaller)} />
          <LineUp onClick={updateSettings(settingsUpdaters.setLhBigger)} />
        </div>
        <button className="absolute cursor-pointer close-button" onClick={onClose}>
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}
